module.exports = __webpack_public_path__ + "img/uploadDocumentIcon.8e3b5106.svg";